
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // 处理邮箱订阅逻辑
    console.log('订阅邮箱:', email);
    setEmail('');
  };

  return (
    <footer className="bg-[#663333] text-white">
      <div className="py-16">
        <div className="mx-auto px-6 lg:px-[15%]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* 品牌信息 */}
            <div className="space-y-4">
              <div className="text-2xl font-bold text-[#cc9966]" style={{ fontFamily: '"Trajan Pro", serif' }}>
                顺年陈
              </div>
              <p className="text-sm text-gray-300 leading-relaxed">
                新一代年份茶的标准制定者与引领者，以透明化体系、数据化标准、可视化体验重构年份茶行业生态。
              </p>
              <div className="flex space-x-4">
                <button className="w-8 h-8 flex items-center justify-center cursor-pointer hover:text-[#cc9966] transition-colors focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded">
                  <i className="ri-wechat-fill text-xl"></i>
                </button>
                <button className="w-8 h-8 flex items-center justify-center cursor-pointer hover:text-[#cc9966] transition-colors focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded">
                  <i className="ri-weibo-fill text-xl"></i>
                </button>
                <button className="w-8 h-8 flex items-center justify-center cursor-pointer hover:text-[#cc9966] transition-colors focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded">
                  <i className="ri-douyin-fill text-xl"></i>
                </button>
              </div>
            </div>

            {/* 产品中心 */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-[#cc9966]">产品中心</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/products" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">糯香小圆片熟茶</Link></li>
                <li><Link to="/products" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">丑甜砖</Link></li>
                <li><Link to="/products" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">顺泰味（2008年）</Link></li>
                <li><Link to="/products" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">七星茶王六堡茶</Link></li>
              </ul>
            </div>

            {/* 信任体系 */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-[#cc9966]">信任体系</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/trust" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">真产地保证</Link></li>
                <li><Link to="/trust" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">真年份追溯</Link></li>
                <li><Link to="/trust" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">真转化科学仓储</Link></li>
                <li><Link to="/honors" className="hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-1">荣誉见证</Link></li>
              </ul>
            </div>

            {/* 邮箱订阅 */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-[#cc9966]">邮箱订阅</h3>
              <p className="text-sm text-gray-300">
                订阅我们的邮件，获取最新产品信息和行业动态
              </p>
              <form onSubmit={handleSubscribe} className="space-y-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入您的邮箱"
                  className="w-full px-3 py-2 bg-[#774444] text-white placeholder-gray-400 border border-[#885555] rounded focus:outline-none focus:border-[#cc9966] focus:ring-2 focus:ring-[#cc9966] text-sm"
                  required
                />
                <button
                  type="submit"
                  className="w-full bg-[#cc9966] text-white py-2 rounded hover:bg-[#bb8855] transition-colors cursor-pointer whitespace-nowrap text-sm focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333]"
                >
                  订阅
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* 版权信息 */}
      <div className="border-t border-[#774444] py-6">
        <div className="mx-auto px-6 lg:px-[15%]">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © 2025 顺年陈 Shunnian Chen. 保留所有权利。
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-2">隐私政策</Link>
              <Link to="/terms" className="text-gray-400 hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-2">使用条款</Link>
              <a href="https://readdy.ai/?origin=logo" target="_blank" className="text-gray-400 hover:text-[#cc9966] transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#cc9966] focus:ring-offset-2 focus:ring-offset-[#663333] rounded px-2">Made with Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
